import styled from 'styled-components';
import { colors, spacing } from 'ui/theme';
import { pxToRem } from 'utils/convert';

export const PanelBody = styled.div`
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  overflow-x: hidden;
  overflow-y: auto;
`;

export const HeaderContainer = styled.div`
  border-bottom: 1px solid ${colors.grey15};
  min-height: ${pxToRem(64)};
`;

export const FooterContainer = styled.div`
  min-height: ${pxToRem(72)};
  display: flex;
  align-items: center;
  gap: ${spacing.half};
  box-sizing: border-box;
  border-top: 1px solid ${colors.grey15};
  justify-content: flex-end;
  padding: ${spacing.base};

  :empty {
    display: none;
  }
`;
